import { ButtonBase } from '@mui/material';

import { UserInteractionEl } from '@/components/DynamicForm/types/DynamicFormTypes';
import { strToSlug } from '@/utils';
import { flattenIntoKey } from '@/components/DynamicForm/utils/utils';
import TAGSvgIcon, { IconName } from '@/components/TAGSvgIcon';

import MarkdownText from '../default/MarkdownText/MarkdownText';

import { userInteractionExpansiveStyles } from './UserInteraction.styles';

export const UserInteractionExpansive = ({ copy, icon, label, disabled, redirect, tagData }: UserInteractionEl) => {
	return (
		<ButtonBase
			className="user-interaction-expansive-root"
			data-test-id={`${strToSlug(label)}-user-interaction`}
			{...flattenIntoKey(tagData, 'data')}
			title={label}
			disabled={disabled}
			onClick={(e) => {
				e.preventDefault();
				if (redirect) {
					window.location.href = redirect;
				}
			}}
			sx={userInteractionExpansiveStyles}
		>
			{icon && !!Object.keys(icon).length && <TAGSvgIcon icon={icon.name as IconName} size={icon.size} />}
			<MarkdownText text={copy} />
		</ButtonBase>
	);
};
